import React, { Component } from 'react';
import {Button} from "react-bootstrap"

class CreateNewProjectButton extends Component {

  render() {
    const { artistScreeningEnabled, userIsAuthorizedArtist, openWizardModal } = this.props;
    return (
      <div align="center">
        { (!artistScreeningEnabled || (artistScreeningEnabled && userIsAuthorizedArtist)) ? (
            <Button variant="success btn-lg"
              className="font-display"
              onClick={openWizardModal}>
                create a new project
            </Button>
          ) : (
            <Button variant="warning btn-lg"
              className="font-display"
              href="http://www.twitter.com/_immutables_art" target="_new">
                contact us to apply as an artist
            </Button>
          )}
      </div>
    );
  }
}

export default CreateNewProjectButton;
